import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { PatientConsent, ConsentPayloadDTO, ConsentResponseDTO } from "@/core/types";

import { appendPatientConsent } from "../queryFunctions/appendPatientConsent";

type Context = {
  previousConsents: PatientConsent[];
  updatedConsent: PatientConsent;
};

type UseAppendConsentMutationOptions = UseMutationOptions<
  ConsentResponseDTO,
  unknown,
  ConsentPayloadDTO,
  Context
>;

export function useAppendConsent(options?: UseAppendConsentMutationOptions) {
  return useMutation({
    mutationFn: appendPatientConsent,
    ...options,
  });
}
